document.addEventListener('click', function (event) {
  const closeBtn = event.target.closest('.product-card__size-close');
  if (closeBtn) {
    event.preventDefault();
    event.stopPropagation();

    const panel = closeBtn.closest('.product-card__quick-buy--sizes');
    if (!panel) return;

    panel.classList.remove('is-open');
    const toggle = panel.querySelector('.product-card__mobile-size-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    return;
  }

  const toggle = event.target.closest('.product-card__mobile-size-toggle');

  // Toggle button click
  if (toggle) {
    event.preventDefault();
    event.stopPropagation();

    const panel = toggle.closest('.product-card__quick-buy--sizes');
    if (!panel) return;

    // Close other opened panels
    document.querySelectorAll('.product-card__quick-buy--sizes.is-open').forEach((openPanel) => {
      if (openPanel !== panel) {
        openPanel.classList.remove('is-open');
        const otherToggle = openPanel.querySelector('.product-card__mobile-size-toggle');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Toggle current panel
    const isOpen = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    return;
  }

  // Click outside any size panel
  if (!event.target.closest('.product-card__quick-buy--sizes')) {
    document.querySelectorAll('.product-card__quick-buy--sizes.is-open').forEach((openPanel) => {
      openPanel.classList.remove('is-open');
      const openToggle = openPanel.querySelector('.product-card__mobile-size-toggle');
      if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
    });
  }
});



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.delivery-countdown').forEach(function (el) {
    const type = el.dataset.countdownType;
    const display = el.querySelector('[data-countdown-display]');
    if (!display) return;

    function getTargetDate() {
      const now = new Date();

      if (type === 'daily_cutoff') {
        const parts = (el.dataset.cutoffTime || '17:00').split(':').map(Number);
        let target = new Date(now);
        target.setHours(parts[0], parts[1] || 0, 0, 0);
        if (target.getTime() <= now.getTime()) {
          target.setDate(target.getDate() + 1);
        }
        return target;
      } else {
        const hours = parseFloat(el.dataset.durationHours || '0');
        return new Date(now.getTime() + hours * 60 * 60 * 1000);
      }
    }

    let targetDate = getTargetDate();

    function tick() {
      const now = new Date();
      let diff = targetDate.getTime() - now.getTime();

      if (diff <= 0) {
        if (type === 'daily_cutoff') {
          targetDate = getTargetDate();
          diff = targetDate.getTime() - now.getTime();
        } else {
          diff = 0;
        }
      }

      const totalSeconds = Math.floor(diff / 1000);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;

      display.textContent = `${String(h).padStart(2, '0')}H ${String(m).padStart(2, '0')}M ${String(s).padStart(2, '0')}S`;
    }

    tick();
    setInterval(tick, 1000);
  });
});

/**
 * Update stock status / delivery countdown badge when the selected variant changes.
 */
function updateVariantStockStatus(root, available) {
  const scope = root || document;

  scope.querySelectorAll('.stock-status[data-in-stock-text], .delivery-countdown[data-in-stock-text]').forEach(function (el) {
    const isAvailable = Boolean(available);
    const text = isAvailable
      ? (el.dataset.inStockText || '')
      : (el.dataset.outOfStockText || '');
    const color = isAvailable
      ? (el.dataset.inStockColor || '#22c55e')
      : (el.dataset.outOfStockColor || '#ef4444');
    const enablePulse = el.dataset.enablePulse === 'true';

    el.dataset.variantAvailable = isAvailable ? 'true' : 'false';

    if (el.classList.contains('stock-status')) {
      el.style.setProperty('--stock-status-color', color);
    } else {
      el.style.setProperty('--delivery-status-color', color);
    }

    const textEl = el.querySelector('.stock-status__text, .delivery-countdown__status-text');
    if (textEl) textEl.textContent = text;

    const statusWrap = el.classList.contains('delivery-countdown')
      ? el.querySelector('.delivery-countdown__status')
      : el;
    if (!statusWrap) return;

    let dot = statusWrap.querySelector('.stock-status__dot, .delivery-countdown__dot');
    if (!text) {
      if (dot) dot.remove();
      return;
    }

    if (!dot) {
      dot = document.createElement('span');
      dot.setAttribute('aria-hidden', 'true');
      dot.className = el.classList.contains('stock-status')
        ? 'stock-status__dot'
        : 'delivery-countdown__dot';
      statusWrap.insertBefore(dot, statusWrap.firstChild);
    }

    const pulseClass = el.classList.contains('stock-status')
      ? 'stock-status__dot--pulse'
      : 'delivery-countdown__dot--pulse';

    if (enablePulse && isAvailable) {
      dot.classList.add(pulseClass);
    } else {
      dot.classList.remove(pulseClass);
    }
  });
}

document.addEventListener('variant:change', function (event) {
  const variant = event.detail && event.detail.variant;
  const productInfo = event.target.closest('product-rerender, .product, .shopify-section') || document;
  updateVariantStockStatus(productInfo, variant ? variant.available : false);
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('variant-picker').forEach(function (picker) {
    var formId = picker.getAttribute('form-id');
    if (!formId) return;

    var buyButtons = document.querySelector('buy-buttons[form="' + formId + '"]');
    if (!buyButtons) return;

    var submitBtn = buyButtons.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    // Button ke andar text "div" mein hai
    var textEl = submitBtn.querySelector('div') || submitBtn;
    var originalText = textEl.textContent.trim();

    var radios = picker.querySelectorAll('input[type="radio"]');
    if (radios.length === 0) return;

    // Page load hote hi sab radio uncheck kar dein aur button disable kar dein
    radios.forEach(function (radio) {
      radio.checked = false;
    });
    textEl.textContent = 'Selecteer een maat'; // "Please select a size" (Dutch)
    submitBtn.disabled = true;
    submitBtn.classList.add('needs-size-selection');

    // Jaise hi customer koi size click kare, button normal ho jaye
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        textEl.textContent = originalText;
        submitBtn.disabled = false;
        submitBtn.classList.remove('needs-size-selection');
      });
    });
  });
});

/**
 * Accordion / FAQ: opening one item closes other open siblings in the same group.
 */
document.addEventListener(
  'click',
  function (event) {
    const summary = event.target.closest('details[is="accordion-disclosure"] > summary');
    if (!summary) return;

    const current = summary.parentElement;
    if (!current || current.open) return;

    const scope = current.parentElement;
    if (!scope) return;

    scope.querySelectorAll(':scope > details[is="accordion-disclosure"]').forEach(function (el) {
      if (el !== current && el.open) {
        el.open = false;
      }
    });
  },
  true
);

/**
 * Cart drawer: keep remove + quantity updates inside the drawer (no cart page redirect),
 * and refresh drawer content immediately so quantities stick.
 */
(function () {
  function patchCartDrawer() {
    const CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype.__millionCartPatched) return;
    CartDrawer.prototype.__millionCartPatched = true;

    const originalOnCartChanged = CartDrawer.prototype._onCartChanged;
    CartDrawer.prototype._onCartChanged = async function (event) {
      const section = this.closest('.shopify-section');
      const sectionId = section ? section.id.replace(/^shopify-section-/, '') : '';

      if (event.detail?.baseEvent === 'line-item:change') {
        const html = event.detail.cart?.sections?.[sectionId];
        if (!html) {
          return originalOnCartChanged.call(this, event);
        }

        const updatedDrawerContent = new DOMParser().parseFromString(html, 'text/html');

        if (event.detail.cart.item_count > 0) {
          const currentInner = this.querySelector('.cart-drawer__inner');
          const updatedInner = updatedDrawerContent.querySelector('.cart-drawer__inner');

          if (!currentInner) {
            const drawer = updatedDrawerContent.querySelector('.cart-drawer');
            if (drawer) {
              this.replaceChildren(
                document.createRange().createContextualFragment(drawer.innerHTML)
              );
            }
          } else if (updatedInner) {
            currentInner.innerHTML = updatedInner.innerHTML;
            const footer = this.querySelector('[slot="footer"]');
            const updatedFooter = updatedDrawerContent.querySelector('[slot="footer"]');
            if (footer && updatedFooter) {
              footer.replaceChildren(...updatedFooter.childNodes);
            }
          }
        } else {
          return originalOnCartChanged.call(this, event);
        }
        return;
      }

      return originalOnCartChanged.call(this, event);
    };
  }

  function patchLineItemQuantity() {
    const LineItemQuantity = customElements.get('line-item-quantity');
    if (!LineItemQuantity || LineItemQuantity.prototype.__millionCartPatched) return;
    LineItemQuantity.prototype.__millionCartPatched = true;

    LineItemQuantity.prototype._onRemoveLinkClicked = function (event) {
      const removeControl = event.target.closest(
        "a[href*='/cart/change'], button[data-line-key][data-quantity]"
      );
      if (!removeControl) return;
      if (removeControl.matches('.quantity-input, input[type="number"]')) return;

      event.preventDefault();
      event.stopPropagation();

      if (removeControl.hasAttribute('data-line-key') && removeControl.hasAttribute('data-quantity')) {
        this._changeLineItemQuantity(
          removeControl.getAttribute('data-line-key'),
          parseInt(removeControl.getAttribute('data-quantity') || '0', 10)
        );
        return;
      }

      const url = new URL(removeControl.href, window.location.origin);
      this._changeLineItemQuantity(
        url.searchParams.get('id'),
        parseInt(url.searchParams.get('quantity') || '0', 10)
      );
    };
  }

  function patchCartCount() {
    const CartCount = customElements.get('cart-count');
    if (!CartCount || CartCount.prototype.__millionKeepVisiblePatched) return;
    CartCount.prototype.__millionKeepVisiblePatched = true;

    const descriptor = Object.getOwnPropertyDescriptor(CartCount.prototype, 'itemCount');
    if (!descriptor || !descriptor.set) return;

    const originalSet = descriptor.set;
    Object.defineProperty(CartCount.prototype, 'itemCount', {
      get: descriptor.get,
      set: function (count) {
        if (this.hasAttribute('data-keep-visible')) {
          if (parseInt(this.textContent, 10) === count) return;
          this.style.opacity = '1';
          this.textContent = count;
          return;
        }
        return originalSet.call(this, count);
      },
      configurable: true,
      enumerable: descriptor.enumerable
    });
  }

  function applyPatches() {
    patchLineItemQuantity();
    patchCartDrawer();
    patchCartCount();
  }

  if (window.customElements) {
    Promise.all([
      customElements.whenDefined('line-item-quantity'),
      customElements.whenDefined('cart-drawer'),
      customElements.whenDefined('cart-count')
    ]).then(applyPatches);
  }
})();

/* Transparent header stays transparent on menu/globe open (until scrolled) */
(function () {
  var SCROLL_SOLID = 500;

  function headerEl() {
    return document.querySelector('store-header');
  }

  function syncTransparent() {
    var header = headerEl();
    if (!header || !header.hasAttribute('allow-transparency')) return;
    if (!window.matchMedia('(min-width: 1001px)').matches) {
      header.classList.remove('is-page-scrolled');
      return;
    }

    var scrolled = window.scrollY >= SCROLL_SOLID;
    header.classList.toggle('is-page-scrolled', scrolled);

    // Theme adds is-filled on [open] / hover — undo while still at top
    if (!scrolled) {
      header.classList.remove('is-filled');
    }
  }

  var scrollTicking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        scrollTicking = false;
        syncTransparent();
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'toggle',
    function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('store-header')) return;
      requestAnimationFrame(syncTransparent);
    },
    true
  );

  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.closest && e.target.closest('store-header')) {
      requestAnimationFrame(syncTransparent);
    }
  });

  function bindHeaderHover() {
    var header = headerEl();
    if (!header || header.__millionTransparencyBound) return;
    header.__millionTransparencyBound = true;
    header.addEventListener('mouseenter', function () {
      requestAnimationFrame(syncTransparent);
    });
    header.addEventListener('mouseleave', function () {
      requestAnimationFrame(syncTransparent);
    });
  }

  bindHeaderHover();
  syncTransparent();
  customElements.whenDefined('store-header').then(bindHeaderHover);
})();

/* Close open header menus/sheets when crossing mobile ↔ desktop + repair blank hero */
(function () {
  var mq = window.matchMedia('(max-width: 1000px)');
  var lastMobile = mq.matches;

  function repairTransparentHero() {
    var roots = document.querySelectorAll(
      '.shopify-section:first-child [allow-transparent-header], [allow-transparent-header]'
    );

    roots.forEach(function (root) {
      // reveal-on-scroll starts at opacity:0 until JS reveal — keep visible after resize
      root.querySelectorAll('[reveal-on-scroll="true"], slideshow-carousel').forEach(function (el) {
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
      });

      var slides = root.querySelectorAll('.slideshow__slide');
      if (slides.length) {
        var selected = root.querySelector('.slideshow__slide.is-selected') || slides[0];
        slides.forEach(function (slide) {
          var on = slide === selected || slide.classList.contains('is-selected');
          if (on) {
            slide.classList.add('is-selected');
            slide.style.setProperty('opacity', '1', 'important');
            slide.style.setProperty('visibility', 'visible', 'important');
            slide.style.setProperty('z-index', '1', 'important');
            slide.querySelectorAll('img, video, video-media, picture, svg').forEach(function (media) {
              media.style.setProperty('opacity', '1', 'important');
              media.style.setProperty('visibility', 'visible', 'important');
              media.style.removeProperty('transform');
            });
          } else {
            slide.style.setProperty('opacity', '0', 'important');
            slide.style.setProperty('visibility', 'hidden', 'important');
            slide.style.setProperty('z-index', '0', 'important');
          }
        });
      }

      root.querySelectorAll('.content-over-media').forEach(function (box) {
        box.style.removeProperty('opacity');
        box.style.removeProperty('visibility');
        box.querySelectorAll('img, video, video-media, picture, iframe, svg').forEach(function (media) {
          media.style.setProperty('opacity', '1', 'important');
          media.style.setProperty('visibility', 'visible', 'important');
        });
      });

      root.querySelectorAll('.slideshow__controls, [data-sequence], .button').forEach(function (el) {
        if (el.style.opacity === '0') el.style.setProperty('opacity', '1');
      });
    });

    var header = document.querySelector('store-header');
    if (header) header.style.removeProperty('transform');
  }

  function resetHeaderUi() {
    if (typeof window.__millionCloseLoc === 'function') {
      try { window.__millionCloseLoc(); } catch (e) {}
    }

    document.querySelectorAll('.loc-sheet.is-open').forEach(function (sheet) {
      sheet.classList.remove('is-open');
      sheet.hidden = true;
      sheet.setAttribute('hidden', '');
    });

    document.querySelectorAll('store-header [open]').forEach(function (el) {
      if (el.tagName === 'DETAILS') {
        el.open = false;
      } else if (typeof el.hide === 'function') {
        try { el.hide(); } catch (e) {}
      } else {
        el.removeAttribute('open');
      }
    });

    var header = document.querySelector('store-header');
    if (header) {
      header.style.removeProperty('transform');
      if (header._hasSwitchedToSticky) header._hasSwitchedToSticky = false;
    }

    repairTransparentHero();
    requestAnimationFrame(function () {
      repairTransparentHero();
      setTimeout(repairTransparentHero, 50);
      setTimeout(repairTransparentHero, 200);
    });
  }

  function onBreakpointChange() {
    var nowMobile = mq.matches;
    if (nowMobile === lastMobile) return;
    lastMobile = nowMobile;
    resetHeaderUi();
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onBreakpointChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(onBreakpointChange);
  }

  var resizeTimer;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        onBreakpointChange();
        // Also repair hero on any significant resize (DevTools device toggle)
        if (document.querySelector('[allow-transparent-header]')) {
          repairTransparentHero();
        }
      }, 150);
    },
    { passive: true }
  );

  // orientationchange (phones / DevTools)
  window.addEventListener('orientationchange', function () {
    setTimeout(resetHeaderUi, 100);
  });
})();

/**
 * Mobile sort uses the theme popover/drawer. On small screens that popover
 * is moved to document.body, so FacetSortBy never hears the selected option.
 */
(function () {
  function sortByFromPopover(popover) {
    if (!popover || !popover.id) return null;
    const trigger = document.querySelector('facet-sort-by [aria-controls="' + popover.id + '"]');
    return trigger ? trigger.closest('facet-sort-by') : null;
  }

  function applySort(sortBy, value) {
    if (!sortBy || !value) return;
    const section = sortBy.closest('.shopify-section');
    if (!section) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.set('section_id', section.id.replace(/^shopify-section-/, ''));
    url.searchParams.delete('page');
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'search') {
      url.searchParams.set('type', 'product');
    }

    sortBy.dispatchEvent(
      new CustomEvent('facet:update', {
        bubbles: true,
        detail: { url: url }
      })
    );
  }

  function handlePortedSort(event) {
    const listbox = event.target && event.target.closest && event.target.closest('x-listbox');
    if (!listbox) return;

    const popover = listbox.closest('x-popover');
    const sortBy = sortByFromPopover(popover);
    if (!sortBy || sortBy.contains(listbox)) return;

    applySort(sortBy, (event.detail && event.detail.value) || (event.target && event.target.value));
  }

  document.addEventListener('listbox:change', handlePortedSort);
  document.addEventListener('listbox:select', handlePortedSort);
})();

/**
 * Product description follows the storefront language.
 * Shopify often stores NL/EN copy in the swapped locale; pick the matching
 * one, and translate only when that language is missing.
 */
(function () {
  var NL_RE =
    /\b(de|het|een|van|voor|met|bij|naar|uit|aan|ook|als|deze|dit|gemaakt|katoen|wassen|mouw|mouwen|kraag|taille|zacht|zachte|comfortabel|artikel|broek|trui|jas|pasvorm|rug|borst|voorkant|achterkant|geborduurd|geborsteld|binnenkant|warmte|katoenen|bestelling|retourneren)\b/gi;
  var EN_RE =
    /\b(the|with|from|this|that|made|cotton|wash|sleeve|sleeves|collar|waist|soft|comfortable|pants|sweater|jacket|fit|back|chest|front|embroidered|printed|fleece|brushed|inside|warmth|understated|committed|signature|artwork|regular|straight|ribbed|cuffs|hem)\b/gi;
  var DE_RE =
    /\b(der|die|das|und|mit|von|fuer|für|ist|sind|baumwolle|waschen|aermel|ärmel|kragen|taille|weich|bequem|hose|pullover|jacke|passform|ruecken|rücken|brust|vorne|hinten|gestickt|bedruckt)\b/gi;

  var jsonCache = {};
  var htmlCache = {};
  var busyHandles = {};

  function currentLang() {
    if (window.__millionLocale === 'en' || window.__millionLocale === 'de' || window.__millionLocale === 'nl') {
      return window.__millionLocale;
    }
    var path = location.pathname || '';
    if (/^\/en(\/|$)/i.test(path)) return 'en';
    if (/^\/de(\/|$)/i.test(path)) return 'de';
    return 'nl';
  }

  function stripHtml(html) {
    var el = document.createElement('div');
    el.innerHTML = html || '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function score(text, re) {
    return ((String(text || '').toLowerCase().match(re) || []).length);
  }

  function detectLang(text) {
    var nl = score(text, NL_RE);
    var en = score(text, EN_RE);
    var de = score(text, DE_RE);
    if (!nl && !en && !de) return '';
    if (nl >= en && nl >= de) return 'nl';
    if (de >= en && de >= nl) return 'de';
    return 'en';
  }

  function productUrl(lang, handle) {
    var prefix = lang === 'en' ? '/en' : lang === 'de' ? '/de' : '';
    return prefix + '/products/' + encodeURIComponent(handle) + '.js';
  }

  function loadProduct(lang, handle) {
    var key = lang + ':' + handle;
    if (!jsonCache[key]) {
      jsonCache[key] = fetch(productUrl(lang, handle), { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .catch(function () {
          return null;
        });
    }
    return jsonCache[key];
  }

  function cacheKey(handle, lang) {
    return 'ms-desc:' + lang + ':' + handle;
  }

  function readStore(handle, lang) {
    try {
      return localStorage.getItem(cacheKey(handle, lang));
    } catch (e) {
      return null;
    }
  }

  function writeStore(handle, lang, html) {
    try {
      localStorage.setItem(cacheKey(handle, lang), html);
    } catch (e) {}
  }

  function pair(from, to) {
    return from + '|' + to;
  }

  function translateChunk(text, from, to) {
    var url =
      'https://api.mymemory.translated.net/get?q=' +
      encodeURIComponent(text) +
      '&langpair=' +
      encodeURIComponent(pair(from, to)) +
      '&de=' +
      encodeURIComponent('webshop@million-store.nl');
    return fetch(url)
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        var out = data && data.responseData && data.responseData.translatedText;
        if (!out || /INVALID|QUERY LENGTH|MYMEMORY WARNING/i.test(out)) return text;
        return out;
      })
      .catch(function () {
        return text;
      });
  }

  function splitChunks(text) {
    if (text.length <= 450) return [text];
    var parts = [];
    var remaining = text;
    while (remaining.length > 450) {
      var cut = remaining.lastIndexOf('. ', 450);
      if (cut < 80) cut = remaining.lastIndexOf(' ', 450);
      if (cut < 80) cut = 450;
      parts.push(remaining.slice(0, cut + (remaining.charAt(cut) === ' ' ? 0 : 1)).trim());
      remaining = remaining.slice(cut + 1).trim();
    }
    if (remaining) parts.push(remaining);
    return parts;
  }

  function translateText(text, from, to) {
    if (!text || from === to) return Promise.resolve(text);
    var chunks = splitChunks(text);
    if (chunks.length === 1) return translateChunk(chunks[0], from, to);
    var out = [];
    var chain = Promise.resolve();
    chunks.forEach(function (chunk, i) {
      chain = chain.then(function () {
        return translateChunk(chunk, from, to).then(function (next) {
          out[i] = next;
        });
      });
    });
    return chain.then(function () {
      return out.join(' ');
    });
  }

  function translateHtml(html, from, to) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html || '';
    var nodes = [];
    var walker = document.createTreeWalker(wrap, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue && walker.currentNode.nodeValue.trim()) {
        nodes.push(walker.currentNode);
      }
    }
    if (!nodes.length) return Promise.resolve(html);

    var chain = Promise.resolve();
    nodes.forEach(function (node) {
      chain = chain.then(function () {
        return translateText(node.nodeValue, from, to).then(function (next) {
          node.nodeValue = next;
        });
      });
    });
    return chain.then(function () {
      return wrap.innerHTML;
    });
  }

  function descFitsTitle(html, title) {
    var text = stripHtml(html).toLowerCase();
    var skip = {
      women: 1,
      body: 1,
      light: 1,
      pink: 1,
      knit: 1,
      top: 1,
      tee: 1,
      shirt: 1,
      black: 1,
      white: 1,
      brown: 1,
      bruin: 1,
      taupe: 1
    };
    var hits = 0;
    String(title || '')
      .toLowerCase()
      .replace(/[^a-z0-9à-ÿ]+/g, ' ')
      .split(' ')
      .forEach(function (word) {
        if (word.length > 3 && !skip[word] && text.indexOf(word) !== -1) hits += 1;
      });
    return hits;
  }

  function applyHandle(handle, lang) {
    if (!handle) return;
    var lock = handle + ':' + lang;
    if (busyHandles[lock]) return;
    busyHandles[lock] = true;

    Promise.all([loadProduct('nl', handle), loadProduct('en', handle), loadProduct('de', handle)])
      .then(function (products) {
        var langs = ['nl', 'en', 'de'];
        var candidates = [];
        products.forEach(function (product, i) {
          var html = product && product.description;
          if (!html) return;
          candidates.push({
            locale: langs[i],
            html: html,
            detected: detectLang(stripHtml(html)),
            fits: descFitsTitle(html, (product && product.handle) || handle)
          });
        });

        var picked = null;
        var fitLang = candidates.filter(function (item) {
          return item.fits > 0 && item.detected === lang;
        })[0];
        var fitAny = candidates.filter(function (item) {
          return item.fits > 0;
        }).sort(function (a, b) {
          return b.fits - a.fits;
        })[0];
        var langOnly = candidates.filter(function (item) {
          return item.detected === lang;
        })[0];
        picked = fitLang || fitAny || langOnly;

        var descEls = document.querySelectorAll('[data-product-desc][data-product-handle="' + handle + '"]');
        if (!descEls.length || !picked) return;

        function writeDesc(html) {
          htmlCache[handle + ':' + lang] = html;
          writeStore(handle, lang, html);
          descEls.forEach(function (el) {
            el.innerHTML = html;
            el.setAttribute('data-desc-ready', lang);
          });
        }

        var stored = htmlCache[handle + ':' + lang] || readStore(handle, lang);
        if (picked.detected === lang) {
          writeDesc(picked.html);
          return;
        }
        if (stored && detectLang(stripHtml(stored)) === lang) {
          descEls.forEach(function (el) {
            el.innerHTML = stored;
            el.setAttribute('data-desc-ready', lang);
          });
          return;
        }
        return translateHtml(picked.html, picked.detected || 'en', lang).then(function (html) {
          if (detectLang(stripHtml(html)) === lang) writeDesc(html);
          else {
            descEls.forEach(function (el) {
              el.setAttribute('data-desc-ready', lang);
            });
          }
        });
      })
      .catch(function () {
        busyHandles[lock] = false;
      });
  }

  function applyAll() {
    var lang = currentLang();
    var seen = {};
    document.querySelectorAll('[data-product-desc][data-product-handle]').forEach(function (el) {
      var handle = el.getAttribute('data-product-handle');
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      applyHandle(handle, lang);
    });
  }

  function start() {
    applyAll();
    document.addEventListener('product:rerender', function () {
      busyHandles = {};
      setTimeout(applyAll, 0);
    });
    if (typeof MutationObserver === 'function' && document.body) {
      new MutationObserver(function () {
        if (document.querySelector('[data-product-desc][data-product-handle]:not([data-desc-ready])')) {
          applyAll();
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
